export default function Section4() {
    return (
        <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20">
           
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">

                {/* Left Side - Text */}
                <div className="md:w-1/2 text-center md:text-left mt-10">

                    <h2 className="text-[24px] md:text-[32px] font-bold text-[#1a1a1a] mb-6 leading-[32px] md:leading-[41px]">
                         Increase Visibility and Revenue with Expert SEO Services in Texas
                    </h2>
                    <p className="text-gray-600 mb-8">
                       Not getting enough traffic from Google? {" "}
                        Mean3 SEO services in {" "}
                       Texas help improve visibility, attract qualified visitors, and grow your business with proven optimization strategies
                    </p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-10">
                        {/* <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Get Your Free SEO Audit
                        </a> */}
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Get Your Free SEO Audit 
                        </a>
                    </div>
                </div>

                {/* Right Side - Hero Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src="/assets/seo-hero.png" // Replace with your hero image path
                        alt="SEO Hero Illustration"
                        className="w-[90%] md:w-[100%] h-auto rounded-lg shadow-lg"
                    />
                </div>
            </div>

            {/* Problem Statement + Issues List */}
            <div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
                {/* Right Side - Existing SEO image */}
                <div className="md:w-1/2">
                    <img
                        src="/assets/SEO.jpg"
                        alt="SEO Problem Illustration"
                        className="w-full h-auto rounded-lg shadow-lg"
                    />
                </div>

                {/* Left Side - Content */}
                <div className="md:w-1/2 text-center md:text-left">
                    <h3 className="text-2xl font-bold text-[#151515] mb-6">
                        Partner with a Leading Texas SEO Firm
                    </h3>
                    <p className="text-gray-600 mb-8">
                       Texas is one of the fastest-growing business markets in the United States, making online competition tougher than ever. Simply having a website isn’t enough you need search engine optimization in Texas that ensures your business appears when potential customers search for your products or services.
                    </p >
                    <p className="text-gray-600 mb-8">
                        Mean3 focuses on strategies that deliver measurable results. We improve your website’s visibility, strengthen online authority, and optimize pages to match the search intent of your target audience.
                    </p>
                     <p className="text-gray-600 mb-8">
                        Our approach combines technical SEO improvements, optimized content, and performance analytics to attract relevant traffic and convert visitors into loyal customers. With the right SEO strategy, your website becomes a powerful marketing asset that consistently generates leads and revenue.
                    </p>
                    <p className="text-gray-600 mb-8">
                       Ready to grow your online presence in Texas?
                    </p>

                    {/* Issues List */}
                    

                    {/* Inline CTA */}
                    <div className="mt-10">
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="inline-block bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
                        >
                            Schedule a Call With Us
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
